var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-checkboxes"},[_c('checkbox-select-custom',{attrs:{"options":_vm.formula,"head":_vm.texts.PRODUCT_FORMULA}}),_c('checkbox-select-custom',{attrs:{"options":_vm.finish,"head":_vm.texts.PRODUCT_FINISH}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }